import { useState } from 'react';

import { rem, Modal, ModalBody, ModalContent, ModalOverlay, Spinner, Center } from '@vimeo/bokeh';
import { Video } from '@vimeo/gctl-api/models/components/schemas/video/Video';

import { CommentPreviewPlayer } from './CommentPreviewPlayer';

type VideoPlayerModalProps = {
  previewClip: Video;
  setPreviewClip: (previewClip: Video | null) => void;
};

export const VideoPlayerModal = ({ previewClip, setPreviewClip }: VideoPlayerModalProps) => {
  const [playerReady, setPlayerReady] = useState(false);
  const { height, width } = getPlayerDimensions(previewClip.width / previewClip.height);

  return (
    <Modal isOpen={!!previewClip} onClose={() => setPreviewClip(null)} size="lg">
      <ModalOverlay width="100%" height="100%" />
      <ModalContent borderRadius="0" width={rem(width)} height={rem(height)} maxW={rem(width)}>
        <ModalBody padding="0" borderRadius="0">
          {!playerReady && (
            <Center
              height="100%"
              width="100%"
              position="absolute"
              borderRadius="sm"
              overflow="hidden"
            >
              <Spinner size="lg" />
            </Center>
          )}
          <CommentPreviewPlayer
            previewClip={previewClip}
            onPlayerReady={() => setPlayerReady(true)}
            height={height}
            width={width}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const MAX_HEIGHT = 700;
const MAX_WIDTH = 700;

const getPlayerDimensions = (aspectRatio: number) => {
  const maxHeight = MAX_HEIGHT;
  const maxWidth = MAX_WIDTH;

  const windowPadding = 72;
  const allowableWidth = window.innerWidth - windowPadding;
  const allowableHeight = window.innerHeight - windowPadding;

  let height: number;
  let width: number;

  // Horizontal videos
  if (aspectRatio > 1) {
    width = maxWidth > allowableWidth ? allowableWidth : maxWidth;
    height = width / aspectRatio;
  }
  // Vertical videos
  else {
    let newHeight = maxHeight > allowableHeight ? allowableHeight : maxHeight;
    let newWidth = newHeight * aspectRatio;
    if (newWidth > allowableWidth) {
      width = allowableWidth;
      height = (newHeight / newWidth) * allowableWidth;
    } else {
      width = newWidth;
      height = newHeight;
    }
  }

  return {
    height,
    width,
  };
};
